
import { defineComponent } from "vue";
import IconArrowLeft from "~icons/tabler/arrow-left";
import Divider from "primevue/divider";
import Map from "@/components/Map.vue";
import { Coordinates, Marker } from "@/typings/Marker";
import { FeedbackItem } from "@/typings/FeedbackItem";
import IconMapPin from "~icons/tabler/map-pin";
import IconCalendarEvent from "~icons/tabler/calendar-event";
import FeedbackTypeIcon from "@/components/publicFeedback/FeedbackTypeIcon.vue";

export default defineComponent({
  data: () => ({
    feedback: null as null | FeedbackItem,
    center: {
      lat: parseFloat(process.env.VUE_APP_CITY_CENTER_LATITUDE),
      lng: parseFloat(process.env.VUE_APP_CITY_CENTER_LONGITUDE),
    } as Coordinates,
    zoom: 14,
    imageIndex: 0,
    showFullDescription: false,
    shouldShowToggle: false,
    selectedImage: null as string | null,
  }),
  methods: {
    updateCenter(value: Coordinates) {
      this.center = value;
    },
    updateZoom(value: number) {
      this.zoom = value;
    },
    getFeedback() {
      if ("id" in this.$route.params === false) {
        return;
      }

      this.$http
        .get("api/v1/public-feedbacks/" + this.$route.params.id)
        .then((response) => {
          this.feedback = response.data;
          this.updateCenter({
            lat: Number(this.feedback?.latitude),
            lng: Number(this.feedback?.longitude),
          });
        });
    },
    toggleDescription() {
      this.showFullDescription = !this.showFullDescription;
    },
    checkDescriptionOverflow() {
      this.$nextTick(() => {
        const desc = this.$refs.descRef as HTMLElement;

        if (desc) {
          this.shouldShowToggle = desc.scrollHeight > desc.clientHeight + 2;
        }
      });
    },
  },
  computed: {
    marker() {
      if (!this.feedback) {
        return [];
      }

      return [
        {
          position: {
            lat: Number(this.feedback?.latitude),
            lng: Number(this.feedback?.longitude),
          },
          icon: "/markers/check-marker.svg",
        },
      ] as Array<Marker>;
    },
    feedbackLocale() {
      if (!this.feedback?.type) {
        return "";
      }

      return this.$t(`feedback.${this.feedback?.type?.name}`);
    },
  },
  watch: {
    "feedback.description": {
      handler() {
        this.showFullDescription = false;
        this.checkDescriptionOverflow();
      },
      immediate: true,
    },
  },
  mounted() {
    this.getFeedback();
    this.checkDescriptionOverflow();
  },
  updated() {
    this.checkDescriptionOverflow();
  },
  components: {
    IconArrowLeft,
    Divider,
    Map,
    IconMapPin,
    IconCalendarEvent,
    FeedbackTypeIcon,
  },
});
